<template>
  <div>
    <vx-card>
      <div class="content">
        <vs-row class="mb-6 flex justify-between">
           <vs-col vs-sm="12" vs-lg="6">
        <vs-row class="mb-6 flex justify-start">
          <vs-col vs-sm="12" vs-lg="12">
              <vs-row>
                <vs-col class="pr-2 flex items-center" vs-sm="12" vs-lg="6">
                  <label>{{$i18n.t('ReportName')}}</label>
                </vs-col>
                <vs-col vs-sm="12" vs-lg="6">
                  <vs-input class="w-full" v-model="reportName"  placeholder="Masukkan nama pengaturan laporan" v-validate="'required'" name="name"/>
                </vs-col>
              </vs-row>
              <span class="mt-1 text-danger flex justify-end text-sm" v-show="errors.has('name')">{{ errors.first('name') }}</span>
          </vs-col>
        </vs-row>
        <vs-row class="mb-6 flex justify-start">
          <vs-col vs-sm="12" vs-lg="12">
              <vs-row>
                <vs-col class="pr-2 flex items-center" vs-sm="12" vs-lg="6">
                  <label>{{$i18n.t('Level1')}}</label>
                </vs-col>
                <vs-col vs-sm="12" vs-lg="6">
                    <vs-select
                      placeholder="Pilih banyak akun"
                      class="w-full"
                      multiple
                      autocomplete
                      v-model="level1Selected"
                      @change="getSubAccounts"
                    >
                      <vs-select-item
                        v-for="(item, index) in optionsLevel1"
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                      />
                    </vs-select>
                </vs-col>
              </vs-row>
          </vs-col>
        </vs-row>
        <vs-row class="mb-6 flex justify-between" v-if="level1Selected.length > 0">
          <vs-col vs-sm="12" vs-lg="12">
                <vs-table
                  multiple
                  search
                  class="scrollable-table"
                  @input="getViewResult"
                  v-model="accountSelectSelected"
                  :data="accountsSelect"
                >
                  <template slot="header">
                    <label class="mb-6">{{$i18n.t('SelectAccount')}}</label>
                  </template>

                  <template slot="thead">
                    <vs-th>
                      {{$i18n.t('NameAccount')}}
                    </vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr
                      v-for="(tr, indextr) in data"
                      :key="indextr"
                      :data="tr"
                      :class="{'opacity-50 pointer-events-none': isDisabled(tr)}"
                      style="display: table-row;"
                    >
                      <vs-td :data="tr.name" style="display: table-cell;">
                        {{ tr.name }}
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
          </vs-col>
        </vs-row>
           </vs-col>

        <vs-col vs-sm="12" vs-lg="5">
              <vs-table
                :data="accountsResult">
                <template slot="header">
                  <label class="mb-6">{{$i18n.t('ViewResult')}}</label>
                </template>
                <template slot="thead">
                  <vs-th>
                    <h3>{{ reportName ? reportName : $i18n.t('TitleReport') }}</h3>
                  </vs-th>

                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td
                      :data="tr.name"
                      class="text-sm py-0 border-0"
                      :class="{'px-8': tr.level === '3'}">
                      {{ tr.name }}
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
        </vs-col>
        </vs-row>

      </div>


      <div class="divider my-2"></div>

      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <vs-button icon-pack="feather" class="mt-2" @click="submitData()">{{$i18n.t('SaveData')}}</vs-button>
          <vs-button to="/report-settings" class="ml-4 mt-2" type="border" color="danger">{{$i18n.t('Cancel')}}</vs-button>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { VMoney } from 'v-money'
import { Validator } from 'vee-validate'
import moduleAccount from '@/store/accounts/moduleAccount.js'

const dict = {
  custom: {
    name: {
      required: 'Nama laporan harus diisi'
    },
    date: {
      required: () => 'Tanggal Voucher harus diisi'
    }
  }
}
Validator.localize('en', dict)

export default {
  components: {
    vSelect
  },
  directives: { money: VMoney },
  data () {
    return {
      reportName: '',
      accountsLevel1: [],
      level1Selected:[],
      loaded: false,
      isDropdownOpen: false,
      optionsLevel1:[],
      accountSelectSelected: [],
      accountsSelect:[],
      accountsResult:[]
    }
  },
  computed: {
    company () {
      return JSON.parse(localStorage.getItem('activeCompany'))
    }
  },
  watch: {

  },
  methods: {
    isDisabled (account) {
      return account.level === '2'
    },
    loading () {
      this.loaded = false
      this.$vs.loading({
        type: 'border',
        color: 'primary',
        text: 'Wait a minute, It\'s getting data.'
      })
    },
    onLoaded () {
      this.loaded = true
      this.$vs.loading.close()
    },
    getAccountLevel (no_level) {
      this.$store.dispatch('accounts/getAccountLevel', {
        no_level,
        company_id: this.company.id
      }).then(resp => {
        this.accountsLevel1 = resp.data.data
        resp.data.data.forEach(account => {
          this.optionsLevel1.push({
            text: account.name,
            value: account.id
          })
        })
      }).catch(err => {
        this.$vs.notify({
          color: 'danger',
          title: 'Opps..',
          text: err
        })
      })
        .finally(() => {
          this.onLoaded()
        })
    },
    getSubAccounts () {
      const prevSelectedIds = this.accountSelectSelected.map(acc => acc.id)

      this.$store.dispatch('accounts/getSubAccount', {
        account_ids: this.level1Selected,
        company_id: this.company.id
      }).then(resp => {
        this.accountsSelect = resp.data.data
        this.accountSelectSelected = this.accountsSelect.filter(acc => prevSelectedIds.includes(acc.id)
        )
      }).catch(err => {
        this.$vs.notify({
          color: 'danger',
          title: 'Opps..',
          text: err
        })
      })
        .finally(() => {
          this.onLoaded()
        })
    },
    getViewResult () {
      const selectedIds = this.accountSelectSelected.map(acc => acc.id)
      const selectedAccounts = this.accountsSelect.filter(account => selectedIds.includes(account.id)
      )

      // Mulai dari hasil yang dipilih
      this.accountsResult = []

      selectedAccounts.forEach((acc) => {
        const accountCode1 = acc.account_code.split('.')[0]
        const accountCode2 = acc.account_code.split('.')[1]

        // Cari akun level 1 yang cocok
        const matchingLevel1 = this.accountsLevel1.find(acc1 => {
          const level1 = acc1.account_code.split('.')[0]
          return level1 === accountCode1
        })

        const matchingLevel2 = this.accountsSelect.find(acc2 => {
          const level1 = acc2.account_code.split('.')[0]
          const level2 = acc2.account_code.split('.')[1]
          return level2 === accountCode2 && level1 === accountCode1
        })

        // Tambahkan level 1 dulu jika belum ada di result
        if (matchingLevel1 && !this.accountsResult.find(a => a.id === matchingLevel1.id)) {
          this.accountsResult.push(matchingLevel1)
        }

        if (matchingLevel2 && !this.accountsResult.find(a => a.id === matchingLevel2.id)) {
          this.accountsResult.push(matchingLevel2)
        }


        // Tambahkan akun yang dipilih
        this.accountsResult.push(acc)
      })
    },
    submitData () {
      this.$store.dispatch('reportSettings/addReportSettings', {
        name: this.reportName,
        company_id: this.company.id,
        account_id: this.accountsResult.map((acc) => acc.id)
      })
        .then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'Berhasil',
            text: 'Voucher berhasil di tambahkan'
          })
          this.$router.push('/report-settings')
        }).catch(err => {
          this.$vs.notify({
            color: 'danger',
            title: 'Opps..',
            text: err
          })
        })
        .finally(() => {
          this.onLoaded()
        })
    }

  },
  created () {
    if (!moduleAccount.isRegistered) {
      this.$store.registerModule('accounts', moduleAccount)
      moduleAccount.isRegistered = true
    }
    this.loading()
    this.getAccountLevel(1)
  }
}
</script>

<style>
  .divider {
    background: #E0E0E0;
    height: 1px;
  }
  .scrollable-table .vs-con-tbody {
    max-height: 300px;  /* Atur sesuai dengan kebutuhan */
    overflow-y: auto;
    display: block;  /* Membuat area body tabel jadi block untuk scroll */
  }

  .scrollable-table .vs-con-table {
    display: block;  /* Memastikan tabelnya menjadi block */
  }

  .scrollable-table .vs-con-thead {
    display: table;  /* Membuat header tetap berada di atas */
    width: 100%;
    table-layout: fixed;  /* Agar kolom tetap sejajar */
  }

  .scrollable-table .vs-tr {
    display: table;
    width: 100%;
  }

  .scrollable-table .vs-td {
    display: table-cell;  /* Menjaga tampilan cell sesuai kolom */
  }
</style>
